package com.evoapps.evoshift.domain.usecase.auth

import com.evoapps.evoshift.domain.repository.AuthRepository

class SendEmailVerificationUseCase(private val authRepository: AuthRepository) {
    suspend operator fun invoke(): Result<Unit> {
        return authRepository.sendEmailVerification()
    }
}

class CheckEmailVerificationUseCase(private val authRepository: AuthRepository) {
    suspend operator fun invoke(): Result<Boolean> {
        // We must reload the user first to get the latest verification status from Firebase servers
        authRepository.reloadUser()
        return Result.success(authRepository.isEmailVerified())
    }
}
